import { Skeleton, cn } from "ui";

type SkeletonToolbarProps = {
  /** Render the "X of Y items" count line.
   * @default true
   */
  withCount?: boolean;
  /** Render the search input placeholder.
   * @default true
   */
  withSearch?: boolean;
  /** Render the filters button placeholder.
   * @default true
   */
  withFilters?: boolean;
  /** Render the date-range picker placeholder (right-aligned).
   * @default false
   */
  withDatePicker?: boolean;
  className?: string;
};

export const SkeletonToolbar = ({
  withCount = true,
  withSearch = true,
  withFilters = true,
  withDatePicker = false,
  className,
}: SkeletonToolbarProps) => (
  <div className={cn("flex flex-col gap-2", className)}>
    {withCount && <Skeleton className="h-4 w-40" />}

    {(withSearch || withFilters || withDatePicker) && (
      <div className="flex flex-wrap gap-4">
        {withSearch && <Skeleton className="h-8 min-w-[200px] flex-1" />}
        {withFilters && <Skeleton className="h-8 w-20" />}
        {withDatePicker && <Skeleton className="ml-auto h-8 w-60" />}
      </div>
    )}
  </div>
);
